import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './7ab62256da26b7145ac7b5e5af41942239c69091222dc1adc80f9f555b34e076.cfe-internal.js';
import '../Tooltip/ca664ad530b3b769c7b76cb94c664b585fc864e665376d1d61d1c56f079a099a.cfe-internal.js';
import Tooltip from '../Tooltip/303de8f785b9987afea88aa6b28176d2cc278b105d33ed5d93d1cf139ee9589d.cfe-internal.js';

var _excluded = ["children", "disabled", "aria-disabled", "className", "type", "tooltipContent", "tooltipPlacement", "isTooltipADescription", "onClick", "onKeyDown"];
var sizePropInIconErrorMessage = 'Warning: The `Icon` prop `size` is invalid when used as a child of `IconButton`.';
var IconButton = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$ariaDisabled = _ref['aria-disabled'],
    ariaDisabled = _ref$ariaDisabled === void 0 ? disabled : _ref$ariaDisabled,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    tooltipContent = _ref.tooltipContent,
    tooltipPlacement = _ref.tooltipPlacement,
    _ref$isTooltipADescri = _ref.isTooltipADescription,
    isTooltipADescription = _ref$isTooltipADescri === void 0 ? false : _ref$isTooltipADescri,
    onClick = _ref.onClick,
    onKeyDown = _ref.onKeyDown,
    rest = _objectWithoutProperties(_ref, _excluded);
  var classes = classNames(className, styles.button, _defineProperty({}, styles.disabled, disabled));
  if (children.props.size) {
    // eslint-disable-next-line no-console
    console.error(sizePropInIconErrorMessage);
  }
  var iconButtonComponent = /*#__PURE__*/React__default.createElement("button", _extends({}, rest, {
    type: type,
    className: classes,
    "aria-disabled": ariaDisabled,
    ref: ref,
    onClick: disabled ? undefined : onClick,
    onKeyDown: disabled ? undefined : onKeyDown
  }), /*#__PURE__*/React__default.cloneElement(children, {
    size: 'medium',
    'aria-hidden': true
  }));
  if (tooltipContent) {
    return /*#__PURE__*/React__default.createElement(Tooltip, {
      content: tooltipContent,
      placement: tooltipPlacement,
      delayMs: 500,
      "aria-hidden": isTooltipADescription ? undefined : true
    }, iconButtonComponent);
  }
  return iconButtonComponent;
});
var IconButton$1 = IconButton;

export { IconButton$1 as default };
